import { put, takeEvery } from "redux-saga/effects";
import { getRecommenderConfig, saveRecommenderConfig } from "../slices";
import { ENDPOINT } from "../../services/apiUrls";
import api from "../../services/api";
import { METHODS } from "../../data/api-method-constants";

export interface ResponseGenerator {
  config?: any;
  data?: any;
  headers?: any;
  request?: any;
  status?: number;
  statusText?: string;
  success?: boolean;
  code?: any;
  results?: any;
  recommendations?: any;
  analytics?: any;
  conversationHistory?: any;
  userPreferences?: any;
  recommendationSettings?: any;
}

function* getRecommenderConfigSaga(action: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: METHODS.GET,
      url: ENDPOINT.RECOMMENDER.getRecommenderConfig,
    });
    if (!response.code) yield put(saveRecommenderConfig(response));
  } catch (error) {
    console.log(error);
  }
}

export default function* root() {
  yield takeEvery(getRecommenderConfig.type, getRecommenderConfigSaga);
}
